// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_yQlzC","list":"list_2tPPr","bi":"bi_29WAn","link":"link_3dIw5"};